export default "__VITE_ASSET__CsJIWR5C__"